/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedOriginalLanguageProvider_item = {
    readonly serviceId: string | null;
    readonly " $refType": "PdpSharedOriginalLanguageProvider_item";
};
export type PdpSharedOriginalLanguageProvider_item$data = PdpSharedOriginalLanguageProvider_item;
export type PdpSharedOriginalLanguageProvider_item$key = {
    readonly " $data"?: PdpSharedOriginalLanguageProvider_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedOriginalLanguageProvider_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedOriginalLanguageProvider_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '59d0823ae3b9a4336def1116df0a9058';
export default node;
